// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAr8D3pe7tBzzpzP8pCJvAtTuGPUnLeXtA',
    authDomain: 'zeus-chat-f77e7.firebaseapp.com',
    databaseURL: 'https://zeus-chat-f77e7.firebaseio.com',
    projectId: 'zeus-chat-f77e7',
    storageBucket: 'zeus-chat-f77e7.appspot.com',
    messagingSenderId: '818784102422',
    appId: '1:818784102422:web:2b4e2a627381eaba'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
